/**
 * Pastel highlight palette used everywhere the user can colour a saved
 * block (Bible verses, CCC paragraphs, Prayers). Exact hex values come
 * from product spec — do NOT alter, they are tuned for legibility on the
 * cream/sand reading background.
 *
 * Each entry has:
 *   • `id`       — short snake_case identifier (persisted in the DB).
 *   • `hex`      — opaque pastel for the row backdrop.
 *   • `dot`      — same hex used by the circular button in the bar (we
 *                  keep it as a separate prop so future tweaks like a
 *                  stronger swatch don't break stored rows).
 *   • `ariaEs`/`ariaEn` — accessible button labels.
 */
export const HIGHLIGHT_COLORS = [
    { id: "red",    hex: "#FADBD8", dot: "#FADBD8", ariaEs: "Rojo",     ariaEn: "Red" },
    { id: "blue",   hex: "#D6EAF8", dot: "#D6EAF8", ariaEs: "Azul",     ariaEn: "Blue" },
    { id: "yellow", hex: "#FCF3CF", dot: "#FCF3CF", ariaEs: "Amarillo", ariaEn: "Yellow" },
    { id: "green",  hex: "#D5F5E3", dot: "#D5F5E3", ariaEs: "Verde",    ariaEn: "Green" },
    { id: "purple", hex: "#EBDEF0", dot: "#EBDEF0", ariaEs: "Púrpura",  ariaEn: "Purple" },
];

const BY_ID = Object.fromEntries(HIGHLIGHT_COLORS.map((c) => [c.id, c]));

/**
 * Resolve a stored `color_id` (or raw hex) to its hex value. Returns
 * `null` for unknown ids so the caller can render the row without a
 * background. Accepts both `color_id` strings ("red") AND raw hex
 * strings ("#FADBD8") so legacy rows that happened to store the hex
 * directly keep rendering correctly.
 */
export function colorIdToHex(colorId) {
    if (!colorId) return null;
    if (colorId.startsWith("#")) return colorId;
    return BY_ID[colorId]?.hex || null;
}
